export default __webpack_public_path__ + "static/media/about-me.27bd65ac.jpg";